import PropTypes from 'prop-types';

export const RedirectPropType = PropTypes.shape({
  id: PropTypes.number,
  oldPath: PropTypes.string,
  newPath: PropTypes.string,
  description: PropTypes.string,
  updatedAt: PropTypes.string,
});
